import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-declaratii-de-avere-si-interese',
  templateUrl: './declaratii-de-avere-si-interese.component.html',
  styleUrls: ['./declaratii-de-avere-si-interese.component.scss']
})
export class DeclaratiiDeAvereSiIntereseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
